import React from 'react';
import './Header.css'
import { VscMenu } from 'react-icons/vsc'
import { AiOutlineClose } from "react-icons/ai";
import { Outlet } from "react-router";
import Footer from "../Footer/Footer";
import ScrollToTop from "../ScrollToTop/ScrollToTop";

class Navbarx extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sixthDiv: window.innerWidth < 1200 ? 'visible' : 'hidden',
            openMobileMenu: false
        };
        this.nav_menu_handler = this.nav_menu_handler.bind(this);
    }


    nav_menu_handler() {
        this.setState({ openMobileMenu: !this.state.openMobileMenu })
        // Your logic for handling the menu click
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        this.setState({
            sixthDiv: window.innerWidth < 1200 ? 'visible' : 'hidden'
        });
    }


    async componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }


    render() {
        return (
            <>
                <div className="nav_body Saira_Medium_White">
                    <div className="nav_nav_div_top_1">
                        {/* Logo Section */}
                        <div className="nav_logo_section">
                            <a href="/">
                                <div className="nav_img">
                                    <img src={'/logo.png'} alt="Logo" />
                                </div>
                            </a>
                        </div>

                        {/* Menu Section - Only visible on desktop */}
                        {this.state.sixthDiv === 'hidden' ? (
                            <div className="nav_menu_section">
                                <ul className="nav_menu">
                                    <li>
                                        <a href="/" >Home</a>
                                    </li>
                                    <li>
                                        <a href="/explore">Collection</a>
                                    </li>
                                    <li>
                                        <a href="/#download">Download</a>
                                    </li>
                                    <li >
                                        <a href="/#contact">Contact</a>
                                    </li>
                                </ul>
                            </div>
                        ) : null}

                        {/* Mobile menu trigger - desktop shows nothing here */}
                        <div className="nav_action_section">
                            {this.state.sixthDiv !== 'hidden' && !this.state.openMobileMenu ? (
                                <div id="navBar_image_menu" className={this.state.sixthDiv} onClick={this.nav_menu_handler}>
                                    <VscMenu className='navBar_image_menu_icon' size={22} />
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
                {
                    this.state.openMobileMenu && this.state.sixthDiv !== 'hidden' ? (
                        <div className='mobile_nav_menu'>
                            <div id="navBar_image_menu" className={this.state.sixthDiv} onClick={this.nav_menu_handler}>
                                <AiOutlineClose className='navBar_image_menu_icon' size={22} />
                            </div>

                            <ul className="mobile_nav_menu_ul">
                                <li onClick={this.nav_menu_handler}>
                                    <a href="/">Home</a>
                                </li>
                                <li onClick={this.nav_menu_handler}>
                                    <a href="/explore">Collection</a>
                                </li>
                                <li onClick={this.nav_menu_handler}>
                                    <a href="/#download">Download</a>
                                </li>
                                <li onClick={this.nav_menu_handler}>
                                    <a href="/#contact">Contact us</a>
                                </li>

                            </ul>
                        </div>
                    ) : null
                }

                <div className="page-content-wrapper">
                    <Outlet />
                </div>

                <Footer />
                <ScrollToTop />
            </>
        )
    }
}

export default Navbarx; 